export default {
  exportJob: {
    sbMain: {},
    exchangeRates: [],
    licenses: [],
    items: [],
    invoices: [],
    dbks: [],
    ar4s: [],
    cesses: [],
    containers: [],
    depbs: [],
    depbParents: [],
    dfias: [],
    itemAccesses: [],
    itemRawMtrls: [],
    jobworks: [],
    packingLists: [],
    rotations: [],
    statements: [],
    stuffs: [],
    supportingDocs: [],
    swConsts: [],
    swCtrls: [],
    swInfoTypes: [],
    schemeAbbreviations: [],
    swProds: [],
    thirdParties: []
  },
  commonExchangeRate: 0,
  sbMain: {
    // mandatory
    jobName: null,
    jobDate: null,
    portLocation: null,
    chaLicenseNo: null,
    transportMode: null,
    // mandatory
    iec: null,
    standardIec: true,
    exporterBranch: null,
    exporterName: null,
    exporterAddress1: null,
    exporterAddress2: null,
    exporterCity: null,
    exporterState: null,
    exporterPin: null,
    exporterType: "R",
    exporterClass: "P",
    stateCodeOfOriginExporter: null,
    stateCodeOfOriginExporterDropdownValue: null,
    exporterAdCode: null,
    exporterBankName: null,
    epzCode: null,
    consigneeName: null,
    consigneeAddress1: null,
    consigneeAddress2: null,
    consigneeAddress3: null,
    consigneeAddress4: null,
    consigneeCountryCode: null,
    consigneeCountryCodeDropdownValue: null,
    nfeiSbCategory: null,
    rbiWaiverNo: null,
    rbiWaiverDate: null,
    portCodeOfLoading: null,
    portCodeOfLoadingDropdownValue: null,
    portCodeOfDestination: null,
    portCodeOfDestinationDropdownValue: null,
    countryCodeOfFinalDestination: null,
    countryCodeOfFinalDestinationDropdownValue: null,
    countryCodeOfDischarge: null,
    countryCodeOfDischargeDropdownValue: null,
    portCodeOfDischarge: null,
    portCodeOfDischargeDropdownValue: null,
    sealType: null,
    natureOfCargo: null,
    grossWeight: null,
    netWeight: null,
    unitOfMeasurement: null,
    unitOfMeasurementDropdownValue: null,
    packingUnit: null,
    packingUnitDropdownValue: null,
    totalNoOfPackages: null,
    marksAndNos: null,
    noOfLoosePackets: null,
    noOfContainers: null,
    mawbNo: null,
    hawbNo: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null,
    gstnType: null,
    gstnId: null
  },
  exchangeRate: {
    exchangeRates: null,
    invoiceCurrencyCode: null,
    currencyName: null,
    unitInRs: null,
    rate: null,
    effectiveDate: null,
    whetherStandardCurrency: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  license: {
    schemeAbbreviation: null,
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    registrationNo: null,
    registrationDate: null,
    itemSrNoInPart_E: null,
    itemSrNoInPart_C: null,
    quantity: null,
    quantityDropdownValue: null,
    exportQuantity: null,
    whetherIndegenous: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  count: {
    lastInvoiceNumber: 0,
    lastItemNumber: 0,
    lastDrawbackNumber: 0
  },
  invoice: {
    invoiceSrNo: null,
    invoiceName: null,
    invoiceDate: null,
    exchangeRate: null,
    invoiceCurrencyCode: null,
    invoiceCurrencyCodeDropdownValue: null,
    natureOfContract: null,
    invoiceValue: null,
    buyerName: null,
    buyerAddress1: null,
    buyerAddress2: null,
    buyerAddress3: null,
    buyerAddress4: null,
    freightCurrencyCode: null,
    freightCurrencyCodeDropdownValue: null,
    freightAmount: null,
    insuranceRate: null,
    insuranceCurrencyCode: null,
    insuranceCurrencyCodeDropdownValue: null,
    insuranceAmount: null,
    commissionRate: null,
    commissionCurrencyCode: null,
    commissionCurrencyCodeDropdownValue: null,
    commissionAmount: null,
    discountInFOBPercentage: null,
    discountCurrency: null,
    discountCurrencyDropdownValue: null,
    discountAmount: null,
    otherDeductionsPercentage: null,
    otherDeductionsCurrency: null,
    otherDeductionsCurrencyDropdownValue: null,
    otherDeductionsAmount: null,
    unitPriceIncludes: null,
    packagingCharges: null,
    exporterContractNo: null,
    natureOfPayment: null,
    natureOfPaymentDropdownValue: null,
    periodOfPaymentInDays: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null,
    isThirdParty: null,
    thirdPartyIec: null,
    thirdPartyName: null,
    thirdPartyAddress1: null,
    thirdPartyAddress2: null,
    thirdPartyCity: null,
    thirdPartyCountrySubdivision: null,
    thirdPartyCountryCode: null,
    thirdPartyCountryCodeDropdownValue: null,
    thirdPartyPin: null,
    authorizedEconomicOperatorCode: null,
    authorizedEconomicOperatorCodeDropdownValue: null,
    authorizedEconomicOperatorCountryCode: null,
    authorizedEconomicOperatorCountryCodeDropdownValue: null,
    authorizedEconomicOperatorRole: null,
    termsPlace: null
  },
  drawback: {
    invoiceSrNo: null,
    itemSrNo: null,
    dbkScheduleDropdownValue: null,
    dbkScheduleNo: null,
    dbkRate: null,
    dbkAmount: null,
    dbkQuantity: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  ar4: {
    invoiceSrNo: null,
    itemSrNo: null,
    ar4No: null,
    ar4Date: null,
    commissionerate: null,
    division: null,
    range: null,
    remarks: null
  },
  cess: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    cessActCode: null,
    cessActCodeDropdownValue: null,
    quantity: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  container: {
    srNo: null,
    containerNo: null,
    containerSize: null,
    exciseSealNo: null,
    sealDate: null,
    sealTypeIndicator: null,
    sealDeviceId: null,
    movementDocumentType: null,
    movementDocumentNo: null
  },
  depb: {
    invoiceSrNo: null,
    itemSrNo: null,
    groupCode: null,
    itemCode: null,
    quantity: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  depbParent: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    groupCode: null,
    itemCode: null,
    quantity: null,
    unitQuantityCode: null,
    unitQuantityCodeDropdownValue: null,
    quantityPercentage: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  dfia: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    sionGroupCode: null,
    sionSrNo: null,
    sionIoNormSrNo: null,
    quantity: null,
    unitOfMeasurement: null,
    itemDescription: null,
    technicalCharacteristics: null,
    fileNo: null,
    licenseNo: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  item: {
    invoiceSrNo: null,
    itemSrNo: null,
    schemeCode: null,
    schemeCodeDropdownValue: null,
    ritcCode: null,
    ritcCodeDropdownValue: null,
    descriptionOfGoods1: null,
    descriptionOfGoods2: null,
    descriptionOfGoods3: null,
    unitOfMeasurement: null,
    unitOfMeasurementDropdownValue: null,
    quantity: null,
    unitPrice: null,
    unitOfRate: null,
    unitOfRateDropdownValue: null,
    noOfUnit: 1,
    itemValue: null,
    pmvCalculationPercentage: null,
    presentMarketValue: null,
    jobWorkNotificationNo: null,
    isThirdParty: "N",
    rewardItem: "Y",
    itemProducerCodeType: null,
    itemProducerCode: null,
    itemProducerAddress1: null,
    itemProducerAddress2: null,
    itemProducerCity: null,
    itemProducerCountrySubdivision: null,
    itemProducerPin: null,
    itemProducerCountryCode: null,
    itemProducerCountryCodeDropdownValue: null,
    sourceState: null,
    sourceStateDropdownValue: null,
    transitCountry: null,
    transitCountryDropdownValue: null,
    accessoryStatus: "0",
    accessoryStatusDropdownValue: null,
    endUseOfItem: null,
    endUseOfItemDropdownValue: null,
    hawbNo: null,
    rodtepClaimed: "N",
    totalPackage: null,
    igstPercent: null,
    igstPaymentStatus: null,
    igstPaymentStatusDropdownValue: null,
    taxableValue: null,
    igstAmount: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  itemAccess: {
    invoiceSrNo: null,
    itemSrNo: null,
    descriptionAccessories: null
  },
  itemRawMaterial: {
    invoiceSrNo: null,
    itemSrNo: null,
    rawMaterialCode: null,
    rawMaterialCodeDropdownValue: null,
    quantity: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  jobwork: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    beNo: null,
    beDate: null,
    beInvoiceSrNo: null,
    beInvoiceNo: null,
    beItemNo: null,
    bePortCode: null,
    bePortCodeDropdownValue: null,
    beQtyUsed: null,
    QtyUnits: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null
  },
  packingList: {
    packingNoFrom: null,
    packingNoTo: null,
    packingCode: null
  },
  rotation: {
    rotationDate: null,
    rotationNo: null
  },
  statement: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    statementType: null,
    statementCode: null,
    statementTextFlatFile: null,
    statementText: null
  },
  stuff: {
    factoryStuffed: null,
    sampleAccompanied: null
  },
  supportingDoc: {
    invoiceSrNo: 0,
    itemSrNo: 0,
    srNo: null,
    imgReferenceNo: null,
    documentTypeCode: null,
    icegateFileName: null,
    documentLevelTitle: null,
    documentIssuingPartyCode: null,
    documentIssuingPartyNameAddress1: null,
    documentIssuingPartyNameAddress2: null,
    documentIssuingPartyNameCity: null,
    documentIssuingPartyNamePin: null,
    documentReferenceNo: null,
    placeOfIssue: null,
    documentIssueDate: null,
    documentExpiryDate: null,
    documentBeneficiaryPartyCode: null,
    documentBeneficiaryPartyNameAddress1: null,
    documentBeneficiaryPartyNameAddress2: null,
    documentBeneficiaryPartyNameCity: null,
    documentBeneficiaryPartyNamePin: null,
    fileType: null,
    documentIssuingPartyName: null,
    documentBeneficiaryPartyName: null,
    icegateId: null
  },
  swConst: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    constituentElementName: null,
    constituentCode: null,
    constituentPercentage: null,
    constituentYieldPercentage: null,
    activeIngredient: null
  },
  swCtrl: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    controlTypeCode: null,
    controlLocation: null,
    controlStartDate: null,
    controlEndDate: null,
    controlResultCode: null,
    controlResultRemarks: null
  },
  swInfoType: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    infoType: null,
    infoQualifier: null,
    infoCode: null,
    infoText: null,
    infoMsr: null,
    infoMsrDropdownValue: null,
    infoUqc: null
  },
  swProd: {
    invoiceSrNo: null,
    itemSrNo: null,
    srNo: null,
    productionBatchIdentifier: null,
    productionBatchQuantity: null,
    infoQualifier: null,
    unitQuantityCode: null,
    unitQuantityCodeDropdownValue: null,
    dateOfManufacturing: null,
    dateOfExpiry: null,
    bestBefore: null
  },
  thirdParty: {
    invoiceSrNo: null,
    itemSrNo: null,
    iec: null,
    branchSrNo: null,
    exporterName: null,
    exporterAddress1: null,
    exporterAddress2: null,
    city: null,
    pin: null,
    amendmentType: null,
    amendmentNo: null,
    amendmentDate: null,
    gstnType: null,
    gstnId: null
  },
  schemeAbbreviations: [],
  //   schemeAbbreviation: {
  //     schemeCode: null,
  //     scheme: null,
  //     invoiceSrNo: null,
  //     itemSrNo: null
  //   },
  exportJobId: null,
  isInvoiceProductsPagePassed: false
};
